(() => {
  function t() {
    (subSliderInit(!0), sliderInit(!0), popupSliderInit(!0));
  }
  function n(e, t) {
    var o = e.clientHeight;
    ((e.style.transitionProperty = "height, margin, padding"),
      (e.style.transitionDuration = t + "ms"),
      (e.style.boxSizing = "border-box"),
      (e.style.overflow = "hidden"),
      (e.style.height = o + "px"),
      (e.style.paddingTop = "0"),
      (e.style.paddingBottom = "0"),
      (e.style.marginTop = "0"),
      (e.style.marginBottom = "0"),
      setTimeout(function () {
        ((e.style.height = "0"),
          (e.style.paddingTop = "0"),
          (e.style.paddingBottom = "0"),
          (e.style.marginTop = "0"),
          (e.style.marginBottom = "0"));
      }, 10),
      setTimeout(function () {
        ((e.style.display = "none"),
          e.style.removeProperty("height"),
          e.style.removeProperty("padding-top"),
          e.style.removeProperty("padding-bottom"),
          e.style.removeProperty("margin-top"),
          e.style.removeProperty("margin-bottom"),
          e.style.removeProperty("overflow"),
          e.style.removeProperty("transition-duration"),
          e.style.removeProperty("transition-property"));
      }, t));
  }
  let o = (i) => {
      i &&
        i.querySelectorAll(".about__accordion-toggle").forEach((r) => {
          r.addEventListener("click", () => {
            let e = ".product__info-container .about__accordion-toggle";
            if (
              (r.closest(".product__main-dropdowns") &&
                (e = ".product__main .about__accordion-toggle"),
              i.querySelectorAll(e).forEach((e) => {
                e != r && e.classList.remove("active");
              }),
              i.querySelectorAll(e).forEach((e) => {
                e != r && n(e.nextElementSibling, 300);
              }),
              r.classList.contains("active"))
            )
              (r.classList.remove("active"), n(r.nextElementSibling, 300));
            else {
              r.classList.add("active");
              {
                var t = r.nextElementSibling,
                  o = 300;
                ((t.style.overflow = "hidden"),
                  (t.style.height = "0"),
                  (t.style.display = "block"));
                let e = t.scrollHeight;
                (setTimeout(function () {
                  t.style.height = e + "px";
                }, 10),
                  setTimeout(function () {
                    (t.style.removeProperty("overflow"),
                      t.style.removeProperty("height"));
                  }, o));
              }
            }
          });
        });
    },
    r = () => {
      let e = document.querySelector(
        ".main-product .product-form__submit-wrapper",
      );
      if (e) {
        let t = !0,
          o = !1,
          r = () => {
            t || o
              ? (e
                  .closest(".product-form__buttons-row")
                  .removeAttribute("style"),
                e.classList.remove("fixed"))
              : e.classList.contains("fixed") ||
                ((e.closest(".product-form__buttons-row").style.minHeight =
                  e.clientHeight + "px"),
                e.classList.add("fixed"));
          };
        new IntersectionObserver(
          (e) => {
            var [e] = e;
            ((t = e.isIntersecting), r());
          },
          { root: null, rootMargin: "0px 0px 45px 0px", threshold: 0.01 },
        ).observe(document.querySelector(".product-form__buttons"));
        var i = new IntersectionObserver(
          (e) => {
            var [e] = e;
            ((o = e.isIntersecting), r());
          },
          { root: null, rootMargin: "0px", threshold: 0.01 },
        );
        document.querySelector(".footer") &&
          i.observe(document.querySelector(".footer"));
      }
    };
  class e extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      (super.hide(), window.pauseAllMedia());
    }
    show(e) {
      (super.show(e), this.showActiveMedia());
    }
    showActiveMedia() {
      var e = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`,
      );
      "DEFERRED-MEDIA" == e.nodeName &&
        e.querySelector("template")?.content?.querySelector(".js-youtube") &&
        e.loadContent();
    }
  }
  (customElements.get("product-modal") ||
    customElements.define("product-modal", e),
    document.addEventListener("shopify:section:load", function (e) {
      (o(e.target), r(), t());
    }),
    (window.initFeaturedProduct = function (e) {
      e && (subSliderInit(!0), sliderInit(!0));
    }),
    t(),
    o(document.currentScript.parentElement),
    r());
})();
